import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
//import menuItems, { MenuItem } from "./items";
import { useContext, useState } from "react";
import { mergeMenuItems } from "./helpers";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { SubMenuWrapper } from "./components/SubMenuStyles";

export interface MenuItem {
  link?: string;
  icon?: any;
  badge?: string;
  children?: any[];
  name: string;
  permission: string;
}



const renderSidebarMenuItems = ({
  items,
  path,
  openMenu,
  setOpenMenu,
  userData,
}: {
  items: any;
  userData: any;
  path: string;
  openMenu: string[];
  setOpenMenu: Function;
}): JSX.Element => (
  <SubMenuWrapper key={items.path}>
    {items?.reduce(
      (ev: any, item: any) =>
        reduceChildRoutes({ ev, item, path, openMenu, setOpenMenu, userData }),
      []
    )}
  </SubMenuWrapper>
);



const reduceChildRoutes = ({
  ev,
  path,
  item,
  openMenu,
  setOpenMenu,
  userData,
}: {
  ev: JSX.Element[];
  userData: any;
  path: string;
  item: MenuItem;
  openMenu: string[];
  setOpenMenu: Function;
}): Array<JSX.Element> => {

  if (item.name) {
    const key = item.name;
    const array = [];
    const exactMatch = item.link
      ? !!matchPath(
        {
          path: item.link,
          end: false,
        },
        path
      )
      : false;
    // Function to find permissions with name "Resell"

    if (item.children) {
      const partialMatch = item.link
        ? !!matchPath(
          {
            path: item.link,
            end: false,
          },
          path
        )
        : false;
      array.push(key);
      if (userData?.userType === 'SuperAdmin' || item?.children?.some((childe) =>
        userData?.permissions.includes(childe?.permission + `-Read`)
      )) {
        ev.push(
          <SidebarMenuItem
            key={key}
            active={partialMatch}
            open={partialMatch}
            name={item.name}
            icon={item.icon}
            link={item.link}
            badge={item.badge}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            menus={item}
          >
            {renderSidebarMenuItems({
              path,
              items: item.children,
              openMenu,
              userData,
              setOpenMenu,
            })}
          </SidebarMenuItem>
        );
      }
    } else {
      if (userData?.userType === 'SuperAdmin' || userData?.permissions.includes(item.permission + `-Read`)) {
        ev.push(
          <SidebarMenuItem
            key={key}
            active={exactMatch}
            name={item.name}
            link={item.link}
            badge={item.badge}
            icon={item.icon}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            menus={item}
          />
        );
      }
    }
  }
  return ev;
};

function SidebarMenu(props: any) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<any>([]);
  const { routes } = useContext(SidebarContext);
  const sideMenuItems = mergeMenuItems(routes, true);
  return (
    <>
      {sideMenuItems.map((menuItem: any, index: any) => (
        <span key={index}>
          {renderSidebarMenuItems({
            items: menuItem.items,
            path: location.pathname,
            openMenu,
            setOpenMenu,
            userData: props?.userData,
          })}
        </span>
      ))}
    </>
  );
}

export default SidebarMenu;
